import { delay } from '../helpers/utils/delay';

class DecorationSizerVertical {
	constructor(container) {
		this.container = container;
		this.inner = null;
		this.decorations = [];

		this.getElements();

		if (this.canInit()) {
			this.addEvents();

			delay(10).then(() => {
				this.handleParentSize();
			});
		}
	}

	getElements() {
		this.inner = this.container.querySelector('[data-decoration-inner]');
		this.decorations = this.container.querySelectorAll('[data-decoration-vertical]');
	}

	canInit() {
		return this.container !== null && this.inner !== null && this.decorations.length > 0;
	}

	addEvents() {
		window.addEventListener('resize', () => {
			this.handleParentSize();
		});
	}

	handleParentSize() {
		const base = {
			width: 38,
			height: 128,
		};

		const aspect = base.width / base.height;
		let minRepeat = 16;

		if (window.innerWidth >= 1200) {
			minRepeat =
				this.container.dataset.minRepeatLg !== undefined
					? parseInt(this.container.dataset.minRepeatLg, 10)
					: 16;
			this.height = 1580 / minRepeat;
		} else if (window.innerWidth >= 992) {
			minRepeat = 12;
			this.height = (window.innerWidth - 40) / minRepeat;
		} else {
			minRepeat =
				this.container.dataset.minRepeatSm !== undefined
					? parseInt(this.container.dataset.minRepeatSm, 10)
					: 11;
			this.height = (window.innerWidth - 40) / minRepeat;
		}

		this.width = this.height * aspect;

		// console.log(this.width, this.height, aspect);
		const outerHeight = this.getContainerHeight();
		const fits = outerHeight / this.height;

		this.innerHeight = Math.floor(fits) * this.height;

		this.container.style.setProperty('--decoration-v-height', `${Math.floor(this.height) - 2}px`);
		this.container.style.setProperty('--decoration-v-width', `${Math.floor(this.width)}px`);
		// this.container.style.setProperty('--decoration-v-inner', `${Math.floor(this.innerHeight)}px`);

		// this.container.style.setProperty('--decoration-v-height', `${this.height - 2}px`);
		// this.container.style.setProperty('--decoration-v-width', `${this.width}px`);

		// this.container.style.setProperty('--decoration-v-height', `${parseInt(this.height) - 2}px`);
		// this.container.style.setProperty('--decoration-v-width', `${parseInt(this.width)}px`);

		this.container.style.setProperty(
			'--decoration-v-offset',
			`${Math.ceil(this.width) - this.width}px`
		);
		this.container.style.setProperty('--decoration-v-inner', `${this.innerHeight}px`);
	}

	/**
	 *
	 * @returns number
	 */
	getContainerHeight() {
		this.container.style.setProperty('--decoration-v-inner', 'auto');
		const height = this.container.clientHeight;
		this.container.style.setProperty('--decoration-v-inner', `${this.innerHeight}px`);

		return height;
	}
}

function initDecorationSizer() {
	const containers = document.querySelectorAll('[data-decoration-container]');

	if (containers.length > 0) {
		containers.forEach((container) => {
			// eslint-disable-next-line no-new
			new DecorationSizerVertical(container);
		});
	}
}

initDecorationSizer();
